import { MonthlyReportFlyAshLossOfIgnition, MonthlyReportNameEnum } from '@Src/_basic/object/MonthlyReportType';
import { MonthlyReportApi } from '@Src/_basic/protocol/monthlyReport/MonthlyReportApi';
import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MonthlyReportSelect from '../components/MonthlyReportSelect';

const FlyAshLossOfIgnition = () => {
  const { t: i18T } = useTranslation();
  const [tableData, setTableData] = useState<Array<MonthlyReportFlyAshLossOfIgnition>>([]);

  const selectHandler = useCallback(
    (
      factoryId: number,
      exptUnitId: number,
      startTime: number,
      endTime: number,
      specificationId?: number,
      sourceId?: number,
    ) => {
      if (!factoryId || !exptUnitId || !startTime || !endTime || !specificationId) return;

      MonthlyReportApi.getFlyAshLossOfIgnition(
        {
          factoryId,
          exptUnitId,
          startTime,
          endTime,
          specificationId,
          ...(sourceId && { sourceId }),
        },
        (_data) => setTableData(_data),
      );
    },
    [],
  );

  return (
    <MonthlyReportSelect
      title={i18T('REPORT.MONTHLY_REPORT.FLY_ASH_LOSS_OF_IGNITION.TITLE')}
      exptType={MonthlyReportNameEnum.FLY_ASH_LOSS_OF_IGNITION}
      selectHandler={selectHandler}
      tableData={tableData}
    />
  );
};

export default memo(FlyAshLossOfIgnition);
